'use client';

import { Background } from '@brahma/components';
import type { LayoutProps } from '../types/layout.type';
import styles from './layout.module.scss';
const AuthenicationLayout: React.FC<LayoutProps> = ({
  children
}) => {
  return <div className={styles.authenticationLayout} data-sentry-component="AuthenicationLayout" data-sentry-source-file="index.tsx">
      <div className={styles.authenticationContainer}>
        <Background className={styles.background} baseUrl={process.env.NEXT_PUBLIC_STATIC_URL} name={'gridRedDotLg'} data-sentry-element="Background" data-sentry-source-file="index.tsx">
          {children}
        </Background>
      </div>
    </div>;
};
export default AuthenicationLayout;